import MuiSnackbar from '@mui/material/Snackbar';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useAlertState, useAlertUpdater } from '../../../../context/AlertContext';

const Snackbar = () => {
	const { t } = useTranslation('candidate-feedback');
	const { open, message } = useAlertState();
	const { onClose } = useAlertUpdater();
	const snackbarRef = useRef(null);

	const snackbarMessage = useMemo(() => {
		if (message === null) {
			return '';
		}

		return t(message);
	}, [message, t]);

	const handleSnackbarClose = useCallback(() => {
		onClose();
	}, [onClose]);

	// Generate a unique key based on the message to force re-render
	const snackbarKey = useMemo(() => message ?? 'default-snackbar-key', [message]);

	useEffect(() => {
		if (open && snackbarRef.current) {
			snackbarRef.current.focus();
		}
	}, [open, message]);

	return (
		<MuiSnackbar
			ref={snackbarRef}
			key={snackbarKey}
			role="alert"
			open={open}
			message={snackbarMessage}
			onClose={handleSnackbarClose}
			autoHideDuration={10000}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
		/>
	);
};

export default Snackbar;
